import script from "./PropertyTypeFormModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyTypeFormModal.vue?vue&type=script&setup=true&lang=js"

import "./PropertyTypeFormModal.vue?vue&type=style&index=0&id=72d4812c&lang=css"

const __exports__ = script;

export default __exports__